<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8.25" stroke="#F3CD90" stroke-width="1.5"/>
    <path d="M9 3.96289V10.8629M9 13.2629L9 14.4629" stroke="#F3CD90" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconWarningCircle'
}
</script>
